import FeedbacksPage from './FeedbacksPage';

export default FeedbacksPage;
